// extracted by css-extract-rspack-plugin
export default {"root":"_213BcZFQqgkzQXY7A4ppBP"};